import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Team → Pipeline (C-16 S3, GLE-8410). The page ships dark, so the entry
 * waits for `manage/me.features.pipeline`, inside a window from the release
 * to release + 14 days, and each LGA and Admin sees it on two ET days from
 * the switch-on (the default day cap, C16-D425).
 */
export const PIPELINE_2026_10_27: WhatsNewEntryI = {
  id: "2026-10-27-pipeline",
  feature: "pipeline",
  startsAt: "2026-10-27T04:00:00.000Z",
  endsAt: "2026-11-10T05:00:00.000Z",
  title: {
    [LGA]: "Pipeline is now under Team",
    [ADMIN]: "Pipeline is now under Team",
  },
  intro: {
    [LGA]:
      "Command Center's Pipeline moved into the platform, with live data for your workspaces.",
    [ADMIN]:
      "Command Center's Pipeline moved into the platform, with live data for every workspace.",
  },
  sections: [
    {
      id: "pipeline",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.SPARKLES,
      title: "Team → Pipeline",
      items: [
        "Live data: no more Refresh Data.",
        "Recovery queue: every no-show and cancel to win back. Filter by campaign or rep, star or trash a meeting, and open it in the dialer.",
        "Remind the booker from their name on a meeting: they get a bell that opens the dialer on that prospect.",
        "Upcoming: this week day by day, or everything booked from today on.",
        "Analytics: qualification, show and BM→QM rates, qualified meetings with this month's projection, and no-shows by rep.",
        "Outcome dist.: where your GMV comes from, by campaign and by rep. SLA: each campaign group against its monthly target; click a group to set its targets.",
        "Activity: calls, connects, conversations and booked meetings over time. Click a Rates % row, or a rep with no-shows, to see the meetings behind it.",
        "Review: each campaign group's month against its target, with pace and lifecycle; click a group to edit its data, or create one.",
        "The Lead Assigner Tool link is still there. Command Center's report links stop working when it shuts down.",
      ],
      link: { label: "Open Pipeline", href: Router.managePipeline() },
    },
    {
      id: "pipeline-admin",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.SHIELD,
      title: "Admin only",
      items: ["Open any workspace's Pipeline, or All workspaces at once."],
    },
  ],
};
